import React, { createContext, useContext, useMemo, useCallback } from 'react';
import PropTypes from 'prop-types';
import useLocalStorage from '../hooks/useLocalStorage';

const ThemeContext = createContext({
  isDarkMode: true,
  themeId: 'default',
  toggleTheme: () => {},
  setThemeId: () => {},
});

export const useTheme = () => useContext(ThemeContext);

export const ThemeProvider = ({ children }) => {
  const [isDarkMode, setIsDarkMode] = useLocalStorage('theme_is_dark', true);
  const [themeId, setThemeId] = useLocalStorage('theme_id', 'default');

  const toggleTheme = useCallback(() => {
    setIsDarkMode(prevMode => !prevMode);
  }, [setIsDarkMode]);

  const contextValue = useMemo(() => ({
    isDarkMode,
    toggleTheme,
    themeId,
    setThemeId
  }), [isDarkMode, toggleTheme, themeId, setThemeId]);

  return (
    <ThemeContext.Provider value={contextValue}>
      {children}
    </ThemeContext.Provider>
  );
};

ThemeProvider.propTypes = {
  children: PropTypes.node.isRequired,
};

export default ThemeContext;